/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConfigurationHealthRowResponse } from './ConfigurationHealthRowResponse';
import {
    ConfigurationHealthRowResponseFromJSON,
    ConfigurationHealthRowResponseFromJSONTyped,
    ConfigurationHealthRowResponseToJSON,
    ConfigurationHealthRowResponseToJSONTyped,
} from './ConfigurationHealthRowResponse';

/**
 * 
 * @export
 * @interface ConfigurationHealthClassResponse
 */
export interface ConfigurationHealthClassResponse {
    /**
     * 
     * @type {string}
     * @memberof ConfigurationHealthClassResponse
     */
    key?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigurationHealthClassResponse
     */
    title?: string;
    /**
     * 
     * @type {number}
     * @memberof ConfigurationHealthClassResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<ConfigurationHealthRowResponse>}
     * @memberof ConfigurationHealthClassResponse
     */
    rows?: Array<ConfigurationHealthRowResponse>;
}

/**
 * Check if a given object implements the ConfigurationHealthClassResponse interface.
 */
export function instanceOfConfigurationHealthClassResponse(value: object): value is ConfigurationHealthClassResponse {
    return true;
}

export function ConfigurationHealthClassResponseFromJSON(json: any): ConfigurationHealthClassResponse {
    return ConfigurationHealthClassResponseFromJSONTyped(json, false);
}

export function ConfigurationHealthClassResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfigurationHealthClassResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'] == null ? undefined : json['key'],
        'title': json['title'] == null ? undefined : json['title'],
        'count': json['count'] == null ? undefined : json['count'],
        'rows': json['rows'] == null ? undefined : ((json['rows'] as Array<any>).map(ConfigurationHealthRowResponseFromJSON)),
    };
}

export function ConfigurationHealthClassResponseToJSON(json: any): ConfigurationHealthClassResponse {
    return ConfigurationHealthClassResponseToJSONTyped(json, false);
}

export function ConfigurationHealthClassResponseToJSONTyped(value?: ConfigurationHealthClassResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'title': value['title'],
        'count': value['count'],
        'rows': value['rows'] == null ? undefined : ((value['rows'] as Array<any>).map(ConfigurationHealthRowResponseToJSON)),
    };
}

